import type { Contact } from '../../../config/api';
import type {
  ContactMutation,
  ContactStatus,
  ContactType,
  FoundationContact,
} from './contactsFoundationApi';

export function toLegacyStatus(status: ContactStatus): Contact['status'] {
  return status === 'active' ? 'converted' : status;
}

export function fromLegacyStatus(status: string): ContactStatus {
  return status === 'converted' ? 'active' : status as ContactStatus;
}

export function toLegacyType(type: ContactType): Contact['contact_type'] {
  return type === 'organization' ? 'company' : 'individual';
}

export function fromLegacyType(type: string): ContactType {
  return type === 'company' ? 'organization' : 'person';
}

export function toLegacyContact(contact: FoundationContact): Contact {
  return {
    id: contact.id,
    realm_id: contact.realmId,
    name: contact.name,
    email: contact.email || undefined,
    phone: contact.phone || undefined,
    address: contact.address || undefined,
    contact_type: toLegacyType(contact.type),
    status: toLegacyStatus(contact.status),
    tags: contact.tags,
    created_at: contact.createdAt,
    updated_at: contact.updatedAt,
    last_contact_date: contact.lastContactDate || undefined,
    notes: contact.notes || undefined,
    custom_fields: {
      contactAttempts: contact.contactAttempts,
    },
  };
}

export function toContactMutation(contact: Contact): ContactMutation {
  return {
    name: contact.name.trim(),
    type: fromLegacyType(contact.contact_type),
    status: fromLegacyStatus(contact.status),
    email: contact.email?.trim() || null,
    phone: contact.phone?.trim() || null,
    address: contact.address?.trim() || null,
    tags: contact.tags || [],
    notes: contact.notes?.trim() || null,
  };
}
